<template>
  <div id="port-menu">
    <div class="card vx-card p-6">
      <div class="menu-section">
        <div class="header">
          <div class="icon-area">
            <object class="corporate-icon" type="image/svg+xml" :data="iconOffice" fill="#626262"></object>
          </div>
          <div class="title">法人設定</div>
        </div>
        <div class="menu-content">
          <div class="description">法人に登録された港湾、代理店を選択、管理</div>
          <div class="menu-button-area">
            <vs-button
                class="port-menu-button"
                type="border"
                color="#2D9CDB"
                v-for="(item, index) in enterpriseMenuItems"
                :key="index"
                :to="{name: item.path}"
              >
                {{item.name}}
              </vs-button>
          </div>
        </div>
      </div>
    </div>
    <div class="card vx-card p-6 enterprise-port-menu">
      <template v-if="Object.keys(selectedPort).length != 0">
        <div class="menu-section">
          <div class="header">
            <div class="icon-area">
              <feather-icon
                icon="AnchorIcon"
                svgClasses="h-7 w-7"
              />
            </div>
            <div class="title">{{selectedPort.name}}メニュー</div>
            <vs-button
              class="report-download-button"
              color="#2D9CDB"
              @click="clickReportDownload"
            >
              <div class="report-download-button-inner">
                <feather-icon class="mr-2" icon="FileTextIcon" svgClasses="h-5 w-5" />
                <span>日報ダウンロード</span>
              </div>
            </vs-button>
          </div>
          <div class="menu-content">
            <div class="description">選択した港湾の各種管理、ディスプレイ表示の確認</div>
            <div class="menu-button-area">
              <vs-button
                class="port-menu-button"
                type="border"
                color="#2D9CDB"
                v-for="(item, index) in enterprisePortMenuItems"
                :key="index"
                :to="{name: item.path}"
              >
                {{item.name}}
              </vs-button>
            </div>
          </div>
        </div>
        
        <div class="menu-section">
          <div class="header">
            <div class="icon-area">
              <feather-icon
                icon="MonitorIcon"
                svgClasses="h-7 w-7"
              />
            </div>
            <div class="title">{{selectedPort.name}}ディスプレイ</div>
          </div>
          <div class="menu-content">
            <div class="description">選択したディスプレイ用画面を表示</div>
            <div class="link-list">
              <div
                class="list-item"
                :class="{'last-item': index == displaySettings.length-1}"
                v-for="(setting, index) in displaySettings"
                :key="index"
              >
                <router-link :to="{ name: 'addon-port-master-destination-work-display', params: { displayId: setting.number } }" target="_blank">
                  <div class="item-title">ディスプレイ{{setting.number}}</div>
                  <div class="item-description">
                    <template v-if="index == 0">
                      当日の入出港1~{{setting.limit}}件を表示します。この画面はタッチパネルで操作可能です。
                    </template>
                    <template v-else-if="index == 1">
                      当日の入出港{{setting.offset}}~{{setting.offset + setting.limit - 1}}件を表示します。この画面は表示専用です。
                    </template>
                    <template v-else>
                      当日の入出港{{setting.offset}}~{{setting.offset + setting.limit - 1}}件を表示します。
                      (13:00以降は翌日の入出1~{{ setting.limit }}件)を表示します。この画面は表示専用です。
                    </template>
                  </div>
                  <feather-icon
                    class="external-link-icon"
                    icon="ExternalLinkIcon"
                    svgClasses="h-5 w-5"
                  />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </template>
      
      <template v-else>
        <div class="menu-section">
          <div class="header">
            <div class="icon-area">
              <feather-icon
                icon="AnchorIcon"
                svgClasses="h-7 w-7"
              />
            </div>
            <div class="title">港湾メニュー</div>
          </div>
          <div class="menu-content">
            <div class="description">法人設定の「港湾選択」から管理する港湾を選択してください。</div>
          </div>
        </div>
      </template>
    </div>
    <vs-popup class="report-download-popup"  title="日報ダウンロード" :active.sync="reportPopupActive">
      <flat-pickr
        class="input"
        v-model="inputDate"
        placeholder="航海日を選択してください"
        style="width: 180px;"
        :config.sync="configDayPicker"
      />
      <div class="button-area">
        <vs-button class="popup-button" color="#2D9CDB" @click="callDownloadReport">ダウンロード</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import moment from "moment"
import { createNamespacedHelpers } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import FileSaver from 'file-saver'
const { mapActions, mapState } = createNamespacedHelpers("portMaster")

export default {
  components: {
    flatPickr
  },
  data() {
    return {
      iconOffice: require("@/assets/images/icons/lolcal/corporate_fare.svg"),
      selectedControl: null,
      controlMenuItems: [
        {
          title: "ディスプレイ1",
          description: "当日の入出港1~25件を表示します。この画面はタッチパネルで操作可能です。",
          controlKey: "display1",
        },
        {
          title: "ディスプレイ2",
          description: "当日の入出港26〜75件を表示します。この画面は表示専用です。",
          controlKey: "display2",
        },
        {
          title: "ディスプレイ3",
          description: "当日の入出港76〜125件（13:00以降は翌日の入出1〜50件）を表示します。この画面は表示専用です。",
          controlKey: "display3",
        },
      ],
      reportPopupActive: false,
      inputDate: new Date(),
      configDayPicker: {
        dateFormat: "Y-m-d",
        time_24hr: true,
        defaultDate: new Date(),
        locale: Japanese,
        static: true,
        inline: true
      },
    }
  },
  computed: {
    ...mapState({
      selectedPort: state => state.selectedPort,
      portOptions: state => state.portOptions,
      displaySettings: state => state.displaySettings,
      enterprisePortMenuItems: state => state.enterprisePortMenuItems,
      enterpriseMenuItems: state => state.enterpriseMenuItems
    }),
  },
  created() {
    this.getMasterData()
  },
  mounted() {
    let routerViewElement = document.getElementsByClassName("router-view")
    routerViewElement[0].style.padding = "2.2rem"
  },
  methods: {
    ...mapActions(["fetchPorts", "fetchRanks", "fetchDisplaySettings", "selectPort", "exportDailyReports"]),
    clickReportDownload() {
      this.reportPopupActive = true
    },
    getMasterData() {
      // portOption取得
      this.fetchPorts()
      // rank取得
      this.fetchRanks()
      // display取得
      this.fetchDisplaySettings()
    },
    async callDownloadReport() {
      let payload = {
        portId: this.selectedPort.id,
        date: moment(this.inputDate).format("YYYYMMDD")
      }
      this.$vs.loading();
      try {
        let res = await this.exportDailyReports(payload)
        const date = moment(this.inputDate).format("YYYYMMDD")
        const fileName = `日報_${date}.xlsx`
        FileSaver.saveAs(res.data, fileName);
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "ダウンロードに失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
#port-menu {
  .nav-item-top {
    width: 100px;
    padding: 10px;
    color: white;
    background: #2D9CDB;
    border-radius: 6px 0px 0px 6px;
  }
  .card {
    margin-top: 30px;
  }
  .menu-section {
    margin: 10px 0px;
  }
  .header {
    display: flex;
    .icon-area {
      width: 45px;
    }
  }
  .menu-button-area {
    margin: 20px 0px;
  }
  .port-menu-button, .enterprise-menu-button{
    margin: 5px 10px 5px 0px;
    span {
      font-weight: normal;
    }
  }
  .description {
    margin-bottom: 10px;
  }
  .menu-content {
    margin-left: 45px;
  }
  .title {
    font-weight: bold;
    margin-bottom: 15px;
  }
  .report-download-button {
    margin-left: auto;
    &-inner {
      display: flex;
      align-items: center;
    }
  }
  .office-icon {
    fill: #626262;
  }
  .port-select-box {
    margin: 10px 0px;
  }
  .link-list {
    border: 1px solid;
    border-radius: 5px;
    border-color: #E3E4E5;
    overflow: hidden;
    margin: 20px 0px;
  }
  .list-item {
    padding: 15px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid;
    border-color: #E3E4E5;
    cursor: pointer;
    a, a:visited {
      display: flex;
      color: #636363;
      width: 100%;
    }
    &:hover {
      background: #79C0E8;
      transition: 0.2s;
      a {
        color: $pm-white;
      }
    }
    .external-link-icon {
      margin-left: auto;
    }
  }
  .list-item.active{
    background: #2D9CDB;
    color: #F2F2F2;
    overflow: hidden;
  }
  .last-item {
    border-bottom: 0px solid;
  }
  .display-icon {
    margin: 0px 20px;
  }
  .item-title {
    font-weight: bold;
    width: 150px;
  }
  .port-select-box {
    width: 200px;
  }
  .display-button {
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
  }
  .control-area {
    display: flex;
    justify-content: center;
  }
}
.report-download-popup {
  .vs-popup {
    width: 400px !important;
  }
  .vs-popup--content {
    text-align: center;
  }
  .button-area {
    margin-top: 15px;
  }
  .flatpickr-input {
    display: none;
  }
  .flatpickr-day.selected, .flatpickr-day.nextMonthDay.selected, .flatpickr-day.prevMonthDay.selected {
    background: $pm-blue !important;
    border-color: $pm-blue !important;
    &:hover, &:focus {
      background: $pm-blue !important;
      border-color: $pm-blue !important;
    }
  }
}

</style>
